import { render } from "./NotificationSettings.vue?vue&type=template&id=823db2d4&scoped=true&ts=true"
import script from "./NotificationSettings.vue?vue&type=script&lang=ts"
export * from "./NotificationSettings.vue?vue&type=script&lang=ts"

import "./NotificationSettings.vue?vue&type=style&index=0&id=823db2d4&scoped=true&lang=css"

import exportComponent from "/Users/jonas/Developer/Fliegen/KantineV2/webapp/shop-webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-823db2d4"]])

export default __exports__